import i18next from 'i18next';
import permissions from '@shared/config/permissions';
import { INFO_PANE_PAGES } from 'redux_store';
// TODO(Phase 7): legacy table infrastructure imports — same exemption
// pattern as other entities.
import { CUSTOM_TAGS_OPTIONS } from '_legacy/components/Shared/CustomTags';
import FILTER_TYPES from '@shared/ui/Table/Filters/constants';
import { CLAIM_ENTITY_TYPE_SELECTOR_OPTIONS } from '@entities/claim';
import { ALERTS_TYPE_SELECTOR_OPTIONS, CRISIS_TRIGGERED_OPTIONS, STATUS_OPTIONS } from './constants';
import CrisisTriggeredCell from '../ui/CrisisTriggeredCell';

/**
 * Column definitions for the Alerts table. Plain array (no
 * factory) because the table is not parameterised by a patient
 * page in current usage.
 */
export const GET_ALERT_COLUMNS = [
  {
    size: 200,
    header: i18next.t('tables:customTags'),
    accessorKey: 'accountCustomTags',
    permission: permissions.ACCOUNTS_GET,
    filter: { filterType: FILTER_TYPES.SELECT, options: CUSTOM_TAGS_OPTIONS },
    cell: { withBubbles: true },
  },
  {
    size: 220,
    header: i18next.t('tables:account'),
    accessorKey: 'accountBusinessName',
    permission: permissions.ACCOUNTS_GET,
    enableHiding: false,
    filter: { filterType: FILTER_TYPES.SELECT_WITH_DYNAMIC_HINT },
    isDefaultCell: true,
  },
  {
    size: 200,
    header: i18next.t('tables:customId'),
    accessorKey: 'accountCustomIdentifier',
    permission: permissions.ACCOUNTS_GET,
    enableHiding: false,
    filter: {},
    isDefaultCell: true,
  },
  {
    size: 240,
    header: i18next.t('tables:patientFirstName'),
    accessorKey: 'patientFirstName',
    filter: {},
    cell: { infoPanePage: INFO_PANE_PAGES.patient_page },
  },
  {
    size: 240,
    header: i18next.t('tables:patientLastName'),
    accessorKey: 'patientLastName',
    filter: {},
    cell: { infoPanePage: INFO_PANE_PAGES.patient_page },
  },
  {
    size: 200,
    header: i18next.t('tables:patientDOB'),
    accessorKey: 'patientDateOfBirth',
    filter: { filterType: FILTER_TYPES.DATE },
    isDefaultCell: true,
  },
  {
    size: 200,
    header: i18next.t('tables:mrnNumber'),
    accessorKey: 'patientMrnNumber',
    filter: {},
    cell: { infoPanePage: INFO_PANE_PAGES.patient_page },
  },
  {
    size: 250,
    header: i18next.t('tables:entityNameAlert'),
    accessorKey: 'entityName',
    apiKey: 'alerts',
    filter: { filterType: FILTER_TYPES.SELECT_WITH_DYNAMIC_HINT, apiKey: 'alerts' },
    isDefaultCell: true,
  },
  {
    size: 330,
    header: i18next.t('tables:alertTags'),
    accessorKey: 'alertTags',
    filter: { filterType: FILTER_TYPES.SELECT },
    cell: { withBubbles: true },
  },
  {
    size: 200,
    header: i18next.t('tables:orderDate'),
    accessorKey: 'orderDate',
    filter: { shouldRange: true, filterType: FILTER_TYPES.DATE },
    isDefaultCell: true,
  },
  {
    size: 230,
    header: i18next.t('tables:entityType'),
    accessorKey: 'entityType',
    cell: { withBubble: true },
    filter: { filterType: FILTER_TYPES.SELECT, options: CLAIM_ENTITY_TYPE_SELECTOR_OPTIONS },
  },
  {
    size: 200,
    header: i18next.t('tables:viewedBy'),
    accessorKey: 'viewedBy',
    filter: {},
    isDefaultCell: true,
  },
  {
    size: 250,
    header: i18next.t('tables:alertType'),
    accessorKey: 'alertType',
    cell: { withBubble: true },
    filter: { filterType: FILTER_TYPES.SELECT, options: ALERTS_TYPE_SELECTOR_OPTIONS },
  },
  {
    // OI-CDS-04: whether the patient tapped a crisis resource link
    // (911 / 988 / Crisis Text Line) shown for a suicide-risk alert.
    // A tap only proves the link was triggered — never "Called".
    // Value is composed per row by buildCrisisTriggeredCellValue
    // (widget additionalKeys). Sort and filter both go to the API,
    // which orders three-state with the not-applicable alerts last.
    size: 160,
    header: i18next.t('tables:crisisTriggered'),
    accessorKey: 'crisisResourceTriggered',
    filter: { filterType: FILTER_TYPES.SELECT, options: CRISIS_TRIGGERED_OPTIONS },
    cell: { formattedFunction: value => <CrisisTriggeredCell value={value} /> },
  },
  {
    size: 260,
    header: i18next.t('tables:acknowledgeStatus'),
    accessorKey: 'acknowledgeStatus',
    cell: { withBubble: true },
    filter: { filterType: FILTER_TYPES.SELECT, options: STATUS_OPTIONS },
  },
  {
    size: 250,
    header: i18next.t('tables:acknowledgedBy'),
    accessorKey: 'acknowledgedBy',
    filter: {},
    isDefaultCell: true,
  },
  {
    size: 250,
    header: i18next.t('tables:acknowledgedTimestamp'),
    accessorKey: 'acknowledgedTimestamp',
    filter: { shouldRange: true, filterType: FILTER_TYPES.DATE },
    isDefaultCell: true,
  },
  {
    size: 250,
    header: i18next.t('tables:dateTriggered'),
    accessorKey: 'createdTimestamp',
    filter: { shouldRange: true, filterType: FILTER_TYPES.DATE },
    isDefaultCell: true,
  },
  {
    size: 230,
    header: i18next.t('tables:assessmentName'),
    accessorKey: 'entityName',
    filter: { filterType: FILTER_TYPES.SELECT_WITH_DYNAMIC_HINT },
    isDefaultCell: true,
  },
];
